import RoomElement from './RoomElement'
import game from '../../Game/GameInstance'
import RGBA from '../../Fonts/RGBA'
import UrlExecutor from '../../Api/UrlExecutor'
import ImageContainer from "../../Images/ImageContainer";
import CircleRenderer from "./CircleRenderer";
import {ChairRender} from "./ChairRender";
import ImageRenderer from "./ImageRenderer";

let personSize = 32;
let hMargin = 6;
let vMargin = 10;

let debug = false;

export default class PeoplePositioner extends RoomElement {

    constructor() {

        super(...arguments);

        switch (this.room.size) {
            case 'L':
                this.colums = 12;
                this.rows = 6;
                break;
            case 'M':
                this.colums = 8;
                this.rows = 5;
                break;
            case 'S':
                this.colums = 6;
                this.rows = 3;
                break;
        }

        this.box = this.getBox();

    }

    positionInGrid() {

        let box = this.box;
        let maxPeople = this.room.data.mode === 'table' ? 8 : this.colums * this.rows;
        let indicator = this.room.personIndicator;

        let speakers = [];
        let n = this.room.speakers.length;
        while (n--) {
            speakers.push(1 * this.room.speakers[n].model.data.id);
        }

        let people = this.room.people.filter((person) => {

            if (speakers.includes(person.data.id * 1)) {
                person.hide('Is speaker');
                return false;
            }
            return true;

        });


        if (game.view === 'speakers') {
            indicator.hide('Speaker view');
            this.hideAllPeople();
            return;
        }

        if (this.room.data.mode === 'lobby') {
            // console.log(this.room.waiters.length);
            indicator.x = this.room.x + indicator.center.x + 16;
            indicator.y = this.room.y + this.room.height + indicator.center.y - indicator.height - 16;
            indicator.zIndex = 1000 - people.length;
            return;

        }

        if (this.room.data.children && this.room.data.children.length) {
            let i = people.length;
            while (i--) {
                let person = people[i];
                person.hide('Is in one of this rooms children');
            }
            return;
        }


        if (people.length > maxPeople) {

            // remove last item
            maxPeople--;

            let position = this.getGridPosition(box, maxPeople);

            indicator.x = position.x + this.room.x + indicator.center.x;
            indicator.y = position.y + this.room.y + indicator.center.x;
            indicator.setCount(people.length - maxPeople);
            indicator.zIndex = 1000 - maxPeople;

            indicator.show();

            this.room.hoverMask.add('person-' + maxPeople, position.x, position.y, personSize, personSize)
                .enable()
                .over(() => {

                    let coord = game.mapCoordToScreenCoord(this.room.x + position.x, this.room.y + position.y);

                    game.hoverNameList.setPeople(people.slice(maxPeople));

                    // center
                    game.hoverNameList.x = coord.x + personSize / 2;
                    // bottom
                    game.hoverNameList.y = coord.y + personSize;
                    game.hoverNameList.show();

                    let height = game.hoverNameList.height;
                    let width = game.hoverNameList.width;

                    this.room.hoverMask.add('hovernamelist', position.x - width / 2, position.y, width, height + personSize)
                        .repeat(true)
                        .over((x, y) => {

                            // convert mouse position to game position
                            x += this.unscale(game.x);
                            y += this.unscale(game.y);

                            // extract room position
                            x -= this.room.x;
                            y -= this.room.y;

                            // extract hovernamelist position
                            x -= position.x;
                            y -= position.y;

                            // add width / 2, because the base of this element is positioned in the center
                            x += width / 2;

                            game.hoverNameList.hover(x, y);

                        })
                        .click((x, y) => {
                            y -= position.y;
                            game.hoverNameList.click(x, y);
                        })
                        .out(() => {

                            game.hoverNameList.hide();
                            this.room.hoverMask.remove(/hovernamelist/);

                        });


                })
                .out(() => {
                    game.setToolTipText(null);
                })
                .click(() => {

                });


        } else {
            indicator.hide();
        }

        let i = maxPeople;
        while (i--) {

            let position = this.getGridPosition(box, i);

            if (people[i]) {

                let person = people[i];

                person.x = position.x + this.room.x + person.center.x;
                person.y = position.y + this.room.y + person.center.y;
                person.zIndex = 1000 - i;
                person.show();
                person.needsPositioning = true;

                this.room.hoverMask.add('person-' + i, position.x, position.y, personSize, personSize)
                    .enable()
                    .over(() => {
                        game.setToolTipText(this.room.x + position.x + personSize / 2, this.room.y + position.y + personSize, person.getName(), false);
                    })
                    .out(() => {
                        game.setToolTipText(null);
                    })
                    .click(() => {
                        UrlExecutor.execute(person.data.url);
                    });

                continue;
            }

            game.layers.people.needsSort = true;

            this.room.hoverMask.add('person-' + i, position.x, position.y, personSize, personSize).disable();

        }

        for (i = maxPeople; i < people.length; i++) {
            people[i].hide('Room full');
        }


    }

    getRoomCenter() {
        let width = this.room.width - (hMargin * 2)
        let height = this.room.height - (hMargin * 2)
        let x = (hMargin + (width / 2));
        let y = (vMargin + (height / 2)) + 40;


        return [x, y];
    }

    getTableRadius() {

        return (this.room.width) / 4;
    }

    getGridPosition(box, i) {
        if (this.room.data.mode === 'table') {
            // let count = Math.min(10, Math.max(this.room.people.length, 2));

            let order = [
                0,
                4,
                6,
                2,
                1,
                5,
                3,
                7
            ];
            if (order[i]) {
                i = order[i];
            }


            let [centerX, centerY] = this.getRoomCenter()
            let radius = this.getTableRadius()
            let angle = ((Math.PI * 2) / 8) * i
            let x = centerX + (radius * Math.cos(angle)) - (personSize / 2);
            let y = centerY + (radius * Math.sin(angle)) - (personSize / 2);
            return {x, y};
        }

        let x = box.x + (i % this.colums) * (personSize + hMargin);
        let y = box.y + Math.floor(i / this.colums) * (personSize + vMargin);
        return {x, y};
    }


    render(ctx) {

        if (game.view === 'speakers') {
            let indicator = this.room.personIndicator;
            indicator.hide('Room is in speaker mode');

            this.hideAllPeople();
            return;
        }

        let box = this.box;

        if (this.room.data.mode === 'table') {
            let [centerX, centerY] = this.getRoomCenter()

            if (this.room.data.chair_url) {
                if (!this.room.chair_image) {
                    this.room.chair_image = new ChairRender(this.room, this.room.data.chair_url)
                }

                for (let i = 0; i < 8; i++) {
                    let angle = ((Math.PI * 2) / 8) * i;
                    this.room.chair_image.render(ctx, centerX, centerY, this.getTableRadius(), angle)
                }
            }

            if (this.room.data.table_url) {
                if (!this.room.table_image) {
                    this.room.table_image = new ImageRenderer(this.room, this.room.data.table_url)
                }
                this.room.table_image.render(ctx, this.scale(centerX), this.scale(centerY), this.scale(this.getTableRadius()))
            }

            if (this.room.data.company_url) {
                if (!this.room.company_image) {
                    this.room.company_image = new ImageRenderer(this.room, this.room.data.company_url)
                }
                this.room.company_image.render(ctx, this.scale(centerX), this.scale(centerY), this.scale(this.getTableRadius() / 2))
            }
        }

        if (debug) {
            this.debugBox(ctx, box);

            let i = this.colums * this.rows;
            while (i--) {

                let position = this.getGridPosition(box, i);

                ctx.beginPath();
                ctx.arc(this.scale(position.x + personSize / 2), this.scale(position.y + personSize / 2), this.scale(personSize / 2), 0, Math.PI * 2);

                // ctx.rect(this.scale(x), this.scale(y), this.scale(personSize), this.scale(personSize));
                ctx.fillStyle = new RGBA().random();
                ctx.fill();


            }
        }

    }

    getBox() {

        let width = this.colums * (personSize + hMargin) - hMargin;
        let height = this.rows * (personSize + vMargin) - vMargin;

        let x = (this.roomWidth() - width) / 2;
        let y = 155;

        return {x, y, width, height};

    }

    hideAllPeople() {
        // remove all interactions with people
        this.room.hoverMask.remove(/person/);

        // loop all people and remove them
        let i = this.room.people.length;
        while (i--) {
            this.room.people[i].hide('Hiding all people');
        }

    }

}
